module.exports = __webpack_public_path__ + "media/dashboard/assets/images/menu-icons/question-mark-7fdfd35a72cabb065aa0a52ef57a027f.svg";